import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-4 sm:px-0 justify-start items-end border-a dark:border-gray-900 mb-6 sm:flex hidden" }
const _hoisted_2 = { class: "transaction-card-tab flex justify-center items-center" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = { class: "flex flex-col rounded-lg overflow-hidden px-6 py-4 space-y-2 text-gray-300 text-sm w-full" }

import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { FullPool } from '@/services/balancer/subgraph/types';

import Activities from './PoolActivities/Activities.vue';
import AboutPools from './AboutPools/Index.vue';
import Swaps from './PoolSwaps/Swaps.vue';

import { PoolTransactionsTab } from './types';

type Props = {
  pool: FullPool;
  loading: boolean;
  isIncentivized: string;
  titleTokens: any;
};
/**
 * STATE
 */

export default _defineComponent({
  props: {
    pool: { type: null, required: true },
    loading: { type: Boolean, required: true },
    isIncentivized: { type: String, required: true },
    titleTokens: { type: null, required: true }
  } as unknown as undefined,
  setup(__props: {
  pool: FullPool;
  loading: boolean;
  isIncentivized: string;
  titleTokens: any;
}) {

const props = __props
const { t } = useI18n();

/**
 * TYPES
 */
let tabs = [
  {
    value: PoolTransactionsTab.ABOUT_THIS_POOL,
    label: t('poolTransactions.tabs.aboutThisPool')
  },
  {
    value: PoolTransactionsTab.ALL_ACTIVITY,
    label: t('poolTransactions.tabs.allInvestments')
  },
  {
    value: PoolTransactionsTab.SWAPS,
    label: t('poolTransactions.tabs.swaps')
  },
  {
    value: PoolTransactionsTab.USER_ACTIVITY,
    label: t('poolTransactions.tabs.myInvestments')
  }
];

/**
 * PROPS
 */


if (props.isIncentivized === 'false') tabs.splice(0, 1);
const activeTab = ref(tabs[0].value);

return (_ctx: any,_cache: any) => {
  const _component_BalTabs = _resolveComponent("BalTabs")!
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_BalMobileTabs = _resolveComponent("BalMobileTabs")!
  const _component_BalPopover = _resolveComponent("BalPopover")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BalTabs, {
        modelValue: activeTab.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (activeTab.value = $event)),
        tabs: _unref(tabs),
        "no-pad": "",
        class: "-mb-px"
      }, null, 8, ["modelValue", "tabs"])
    ]),
    _createVNode(_component_BalPopover, {
      align: "left",
      "no-pad": "",
      bg: "transparent",
      wrapperFull: true,
      class: "sm:hidden block mb-3 w-full"
    }, {
      activator: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("label", _hoisted_3, _toDisplayString(_unref(tabs).find(tab => tab.value === activeTab.value)?.label), 1),
          _createVNode(_component_BalIcon, {
            name: "chevron-down",
            size: "sm",
            class: "ml-6 text-white transition-colors text-right"
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_BalMobileTabs, {
            modelValue: activeTab.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (activeTab.value = $event)),
            tabs: _unref(tabs),
            "no-pad": "",
            class: "-mb-px"
          }, null, 8, ["modelValue", "tabs"])
        ])
      ]),
      _: 1
    }),
    (activeTab.value === _unref(PoolTransactionsTab).ALL_ACTIVITY)
      ? (_openBlock(), _createBlock(Activities, {
          key: 0,
          "pool-activity-type": _unref(PoolTransactionsTab).ALL_ACTIVITY,
          pool: props.pool,
          loading: __props.loading
        }, null, 8, ["pool-activity-type", "pool", "loading"]))
      : _createCommentVNode("", true),
    (activeTab.value === _unref(PoolTransactionsTab).USER_ACTIVITY)
      ? (_openBlock(), _createBlock(Activities, {
          key: 1,
          "pool-activity-type": _unref(PoolTransactionsTab).USER_ACTIVITY,
          pool: __props.pool,
          loading: __props.loading
        }, null, 8, ["pool-activity-type", "pool", "loading"]))
      : (activeTab.value === _unref(PoolTransactionsTab).ABOUT_THIS_POOL && __props.isIncentivized === 'true')
        ? (_openBlock(), _createBlock(AboutPools, {
            key: 2,
            pool: props.pool,
            loading: props.loading,
            titleTokens: props.titleTokens
          }, null, 8, ["pool", "loading", "titleTokens"]))
        : (activeTab.value === _unref(PoolTransactionsTab).SWAPS)
          ? (_openBlock(), _createBlock(Swaps, {
              key: 3,
              pool: __props.pool,
              loading: __props.loading
            }, null, 8, ["pool", "loading"]))
          : _createCommentVNode("", true)
  ], 64))
}
}

})